import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import CreditCardOffOutlinedIcon from '@mui/icons-material/CreditCardOffOutlined';

export const dealsItems = [
  {
    title: "Join the Club",
    description: "Be first in line for premium deals before they’re gone.",
    icon: (
      <Diversity1OutlinedIcon className="w-16 h-16 mb-4" />
    ),
  },
  {
    title: "Get Deal Alerts",
    description:
      "Receive alerts straight to your inbox — no searching required.",
    icon: (
      <MarkEmailReadOutlinedIcon className="w-16 h-16 mb-4" />
    ),
  },
  {
    title: "Sign Up for Free",
    description:
      "We’ll handle the hunt so you can focus on travel plans and never miss an offer.",
    icon: (
      <CreditCardOffOutlinedIcon className="w-16 h-16 mb-4" />
    ),
  },
];

export const membershipClubFAQs = [
    {
      heading: 'How much can I save with membership in The Club? ',
      content:
        'First-Class.com searches hundreds of flights to your destination. FlightDeals or First-Class.com exclusive member-only fares ensure that you will receive the best fares around!',
    },
    {
      heading: 'Do I need a credit card to sign up? ',
      content: 'No, membership is completely free & easy to join',
    },
    {
      heading: 'How long does my membership last? ',
      content: 'Indefinitely',
    },
    {
      heading: 'Do I need to be a member to book? ',
      content: 'Yes – you must be a member!',
    },
    {
      heading: 'Do I need to login?',
      content:
        'Yes – to book for You, Friends & Family, just login with your email and password ',
    },
    {
      heading: 'What are FlightDeals?',
      content:
        'Thousands of searches are made daily on First-Class.com and we look at the results carefully. We then offer you the best fares in your country - from First-Class.com and selected partners. FlightDeals can be sorted by destination, departure month, cabin class, airlines and alliance – based on YOUR preferences! The more flexible you are, the better the chance you will find an amazing deal to your dream destination!',
      isDealsMarket: true,
    },
    {
      heading: 'How often will I receive FlightDeal Alerts?',
      content: 'Twice a week',
      isDealsMarket: true,
    },
    {
      heading: 'Can I book hotels?',
      content:
        'Absolutely! We can book you nearly every hotel in the world! Just use the search engine!',
    },
    {
      heading: 'Booking with First-Class.com',
      content:
        'We offer fabulous member-only fares. If you see a flight you like, just click the link and your easy booking journey begins!',
    },
    {
      heading: 'Booking with our partners',
      content:
        'If you find a cheaper flight with one of our partners, no problem! Just click the link and you are nearly there!',
    },
    {
      heading: 'Can I book for my Family & Friends?',
      content:
        'Yes! The member (you) must make the booking but you can book for all your travel companions!',
    },
    {
      heading: 'What is MapMyTravel?',
      content:
        'Think of MapMyTravel as your personal digital map playpen! It’s a fun & easy to use tool that counts the number of countries that you’ve visited and can create a bucket list of destinations! ',
    },
  ];
  
export const howClubWorksDeals = [
    {
      heading: 'Start with Your Travel Preferences',
      content:
        'Log in to add destinations you`ve travelled to or plan to visit.',
    },
    {
      heading: 'Find the Best Flights & Hotels',
      content:
        'Search and compare hundreds of premium flight & hotel options worldwide and compare prices in seconds.',
    },
    {
      heading: 'Receive Instant Deal Alerts',
      content:
        'Get personalised alerts on member only fares & exclusive discounts sent directly to your inbox',
    },
    {
      heading:
        'Book with Confidence',
      content: 'Book directly with First-Class.com or trusted partners to secure your exclusive fare.',
    },
  ];
  
export const howClubWorksNoDeals = [
    {
      heading: 'Start with Your Travel Preferences',
      content: 'Log in to add destinations you`ve travelled to or plan to visit.',
    },
    {
      heading: 'Find the Best Flights ',
      content:
        'Search and compare hundreds of premium flight options worldwide and compare prices in seconds.',
    },
    {
      heading: 'Look out for member-only fares',
      content: '',
    },
    {
      heading:
        'Book with Confidence',
      content: 'Book directly with First-Class.com or trusted partners to secure your exclusive fare.',
    },
  ];
  
export const dealsCarouselItems = [
    {
      image: '/2023/05/1683541291194-La-sagrada-church-closeup.jpg',
      price: 1200,
      currency: 'USD',
      destination: 'Barcelona',
      origin: 'Sydney',
    },
    {
      image: '/2023/06/1686674550987-bejing-skyline-sunset.jpg',
      price: 2200,
      currency: 'USD',
      destination: 'Beijing',
      origin: 'Oslo',
    },
    {
      image: '/2023/06/1686674821190-Doha-skyline-day.jpg',
      price: 1800,
      currency: 'USD',
      destination: 'Doha',
      origin: 'Stockholm',
    },
    {
      image: '/2023/06/1686675794704-Skyline-day.jpg',
      price: 1500,
      currency: 'USD',
      destination: 'Mumbai',
      origin: 'London',
    },
    {
      image: '/2023/06/1686675020483-junkboat-closeup.jpg',
      price: 1200,
      currency: 'USD',
      destination: 'Hong Kong',
      origin: 'New York'
    },
    {
      image: '/2023/06/1686675093264-iolani-place.jpg',
      price: 1500,
      currency: 'USD',
      destination: 'Honolulu',
      origin: 'Los Angeles'
    },
    {
      image: '/2023/06/1686675155346-Hagia-sophia-museum.jpg',
      price: 1800,
      currency: 'USD',
      destination: 'Istanbul',
      origin: 'Paris'
    },
    {
        image: '/2023/06/1686215025026-liberty-statue-.jpg',
        price: 1200,
        currency: 'USD',
        destination: 'New York',
        origin: 'London'
    },
    {
        image: '/2023/06/1686215109178-sydney-opera-close-up.jpg',
        price: 1500,
        currency: 'USD',
        destination: 'Sydney',
        origin: 'Los Angeles'
    }
];